export default __webpack_public_path__ + "0b210973b4522e3cb7f7972bb9f31be6.svg";